module.exports = __webpack_public_path__ + "src/assets/img/cmdObddataGet.89b9a1da.svg";